import React, { Component } from 'react'
import { Col, Form, Input, Row } from 'antd'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'
import { get } from 'lodash'
import OrganisationsSelect from '../../../../../elements/Select/Organistaions'

class VehicleForm extends Component {
  render() {
    const { vehicle } = this.props
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14, offset: 1 },
      },
    }
    return (
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Company'}>
              {getFieldDecorator('company._id', {
                initialValue: get(vehicle, 'company._id'),
                rules: [{ required: true, message: "Company can't be Empty!" }],
              })(<OrganisationsSelect placeholder={'Company'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <h3>Vehicle Details</h3>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Status'}>
              {getFieldDecorator('status', {
                initialValue: get(vehicle, 'status'),
                rules: [{ required: true, message: "Status can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Status'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Type'}>
              {getFieldDecorator('type', {
                initialValue: get(vehicle, 'type'),
                rules: [{ required: true, message: "Type can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Type'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Make'}>
              {getFieldDecorator('make', {
                initialValue: get(vehicle, 'make'),
                rules: [{ required: true, message: "Make can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Make'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Model'}>
              {getFieldDecorator('model', {
                initialValue: get(vehicle, 'model'),
                rules: [{ required: true, message: "Model can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Model'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Year'}>
              {getFieldDecorator('year', {
                initialValue: get(vehicle, 'year'),
                rules: [{ required: true, message: "Year can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Year'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Registration'}>
              {getFieldDecorator('registration', {
                initialValue: get(vehicle, 'registration'),
                rules: [{ required: true, message: "Registration can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Registration'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Note'}>
              {getFieldDecorator('note', {
                initialValue: get(vehicle, 'note'),
                rules: [{ required: true, message: "Note can't be empty!" }],
              })(<Input style={{ width: '100%' }} placeholder={'Note'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <h3>RTA Salik Account Details</h3>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Account'}>
              {getFieldDecorator('salik.account', {
                initialValue: get(vehicle, 'salik.account'),
                rules: [{ required: true, message: "Account can't be Empty!" }],
              })(<Input placeholder={'Account'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Ermirate'}>
              {getFieldDecorator('salik.ermirate', {
                initialValue: get(vehicle, 'salik.ermirate'),
                rules: [{ required: true, message: "Ermirate can't be Empty!" }],
              })(<Input placeholder={'Ermirate'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Chasis'}>
              {getFieldDecorator('salik.chasis', {
                initialValue: get(vehicle, 'salik.chasis'),
                rules: [{ required: true, message: "Chasis can't be Empty!" }],
              })(<Input placeholder={'Chasis'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Category'}>
              {getFieldDecorator('salik.category', {
                initialValue: get(vehicle, 'salik.category'),
                rules: [{ required: true, message: "Category can't be Empty!" }],
              })(<Input placeholder={'Category'} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Plate'}>
              {getFieldDecorator('salik.plate', {
                initialValue: get(vehicle, 'salik.plate'),
                rules: [{ required: true, message: "Plate can't be Empty!" }],
              })(<Input placeholder={'Plate'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Tag'}>
              {getFieldDecorator('salik.tag', {
                initialValue: get(vehicle, 'salik.tag'),
                rules: [{ required: true, message: "Tag can't be Empty!" }],
              })(<Input placeholder={'Tag'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Year'}>
              {getFieldDecorator('salik.year', {
                initialValue: get(vehicle, 'salik.year'),
                rules: [{ required: true, message: "Year can't be Empty!" }],
              })(<Input placeholder={'Year'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

VehicleForm.propTypes = {}
VehicleForm.defaultProps = {}

export default compose(Form.create(), withLoadingSection)(VehicleForm)
